import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./app/store";
import { Provider } from "react-redux";
import { bootstrapAuth } from "./bootstrap-auth";
const root = ReactDOM.createRoot(document.getElementById("root"));

//Ignore all consoles in production build
// if (process.env.NODE_ENV !== "development") {
//   console.log = () => {};
//   console.error = () => {};
//   console.debug = () => {};
// }
bootstrapAuth();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
